import React, { useContext } from 'react';
import { graphql } from 'gatsby';
import ProductFamilyCarousel from './ProductFamilyCarousel';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';
import { ProductFamily } from '../../templates/StructuredDataContext';
import {
    KontentRadioMultiChoice,
    KontentMedia,
    KontentStringValue,
} from '../../../types/KontentProps';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
type ConfigOptions = 'product_family_data_set' | 'products_selected_manually';

export interface ProductFamilyCarouselProps {
    anchor_name?: KontentStringValue;
    configuration_option: KontentRadioMultiChoice<ConfigOptions>;
    display_title: KontentStringValue;
    product_family: { value: ProductFamily[] };
    explicit_products: { value: ProductPagePreview[] };
    general_large___small_image_selection__large: KontentMedia;
    general_large___small_image_selection__small: KontentMedia;
}

const ProductFamilyCarouselContainer: React.FC<ProductFamilyCarouselProps> = (
    props
) => {
    const pageMetadata = useContext(PageMetadataContext);

    return (
        <ProductFamilyCarousel currentPageSlug={pageMetadata.slug} {...props} />
    );
};

export default ProductFamilyCarouselContainer;

export const fragmentProductFamilyCarousel = graphql`
    fragment ProductFamilyCarousel on kontent_item_component___product_family_carousel {
        elements {
            anchor_name {
                value
            }
            configuration_option {
                value {
                    codename
                }
            }
            display_title {
                value
            }
            product_family {
                value {
                    ... on kontent_item_data___product_family {
                        elements {
                            product_family {
                                name
                                value {
                                    codename
                                    name
                                }
                                taxonomy_group
                                type
                            }
                            products {
                                value {
                                    ...productPagePreview
                                }
                            }
                        }
                    }
                }
            }
            explicit_products {
                value {
                    ...productPagePreview
                }
            }
            general_large___small_image_selection__large {
                ...kontentImage
            }
            general_large___small_image_selection__small {
                ...kontentImage
            }
        }
    }
`;
